import { Box, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { Header } from './components/Header';
import { ChargesTabs } from './components/ChargesTabs';
import { useCharges } from './hooks';
import { TabContext } from '@mui/lab';
import { ChargesKMTabContent } from './components/Tabs/ChargesKMTabContent';
import { ChargesLNTabContent } from './components/Tabs/ChargesLNTabContent';
import { CLOSING_DISCLOSURE, HUD_1, REFINANCE } from 'utils/constants';
import { ChargesJKTabContent } from './components/Tabs/ChargesJKTabContent';
import { ChargesGeneralTabContent } from './components/Tabs/ChargesGeneralTabContent';
import { GeneralChargesProvider } from 'contexts/GeneralChargesContext';

const useStyles = makeStyles((theme: any) => ({
  container: {
    width: '100%',
    padding: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1),
    },
  },
  paper: {
    marginTop: '1rem',
    overflow: 'hidden',
  },
}));

interface Props {
  orderType: string;
  transactionType: string;
}

export const Charges: FC<Props> = ({ orderType, transactionType }) => {
  const classes = useStyles();
  const { currentChargeTabSelected, handleSelectKindTab } = useCharges({
    orderType,
    transactionType,
  });

  return (
    <GeneralChargesProvider orderType={orderType} chargesLetter={currentChargeTabSelected}>
      <Box className={classes.container}>
        <Header currentChargeTabSelected={currentChargeTabSelected} />
        <Paper className={classes.paper}>
          <TabContext value={currentChargeTabSelected}>
            <ChargesTabs
              orderType={orderType}
              transactionType={transactionType}
              currentChargeTabSelected={currentChargeTabSelected}
              onTabChange={handleSelectKindTab}
            />

            <ChargesGeneralTabContent
              currentChargeTabSelected={currentChargeTabSelected}
              orderType={orderType}
              transactionType={transactionType}
            />
            {orderType === CLOSING_DISCLOSURE && transactionType !== REFINANCE && (
              <>
                <ChargesKMTabContent />
                <ChargesLNTabContent />
              </>
            )}
            {orderType === HUD_1 && <ChargesJKTabContent />}
          </TabContext>
        </Paper>
      </Box>
    </GeneralChargesProvider>
  );
};
